var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M26 36.78L11.86 22.64l1.41-1.41L26 33.96l12.73-12.73 1.41 1.41L26 36.78z"}));
}

Arrow.defaultProps = {"data-name":"Layer 1","viewBox":"0 0 52 52"};

module.exports = Arrow;

Arrow.default = Arrow;
